import React from 'react';
import Typography from '@/components/atoms/typography/typography';
import FullTeaserCard from '@/components/organisms/full-teaser-card/full-teaser-card';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';
import Row from '@/components/utilities/row/row';
import styles from './full-teaser.module.scss';

export interface FullTeaserProps extends ModuleWrapperProps {
  /** The header of the teaser */
  headline: string;
  /** Items to show as cards in the teaser module */
  rows: Content.Components['FullTeaserCardDto'][];
}

const FullTeaser = ({ headline, rows, ...rest }: FullTeaserProps) => {
  return (
    <ModuleWrapper {...rest} className={styles.component}>
      <Container>
        <Row className={styles.row}>
          <Column>
            <Typography
              className={styles.headline}
              tag="h2"
              tagStyle="displayMedium"
            >
              {headline}
            </Typography>
          </Column>

          <Column className={styles.column}>
            {rows.map((card, cardIndex) => (
              <FullTeaserCard {...card} key={cardIndex} />
            ))}
          </Column>
        </Row>
      </Container>
    </ModuleWrapper>
  );
};

FullTeaser.displayName = 'FullTeaser';

export default FullTeaser;
